import { render, staticRenderFns } from "./UiInput.vue?vue&type=template&id=10da757c&scoped=true"
import script from "./UiInput.vue?vue&type=script&lang=js"
export * from "./UiInput.vue?vue&type=script&lang=js"
import style0 from "./UiInput.vue?vue&type=style&index=0&id=10da757c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da757c",
  null
  
)

export default component.exports